import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const getPlace = (placeId: number | undefined): Promise<IGetPlace> => {
  return axiosDefaultApi.get(`/api/Places/GetPlaceViaID/${placeId}`);
};

type QueryFnType = typeof getPlace;

type UseGetPlaceOptions = {
  placeId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetPlace = ({ placeId , config }: UseGetPlaceOptions) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [`getPlace_${placeId}`],
    queryFn: () => getPlace(placeId),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση της Τοποθεσίας.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};